/* eslint-disable react/no-danger */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import React from 'react'
import cx from 'classnames'

const SVG = ({ className, name, src, title, ...rest }) => {
  let finalSrc = src

  if (name) {
    finalSrc = require(`../../assets/icon-${name}.svg`)
  }

  if (!finalSrc) {
    return null
  }

  if (finalSrc.content) {
    return (
      <svg
        className={cx(
          'Icon',
          {
            [`Icon-${name}`]: Boolean(name),
          },
          className
        )}
        {...finalSrc.attributes}
        {...rest}
        title={title}
      >
        <g dangerouslySetInnerHTML={{ __html: finalSrc.content }} />
      </svg>
    )
  }

  return <img className={className} src={finalSrc} alt="" {...rest} />
}

export default SVG



// WEBPACK FOOTER //
// ./src/components/SVG/index.js